const IS_PAGE_LOADING_UPDATED = (state, isPageLoading) => {
  state.isPageLoading = isPageLoading
}

const IS_COMPONENT_LOADING_UPDATED = (state, isComponentLoading) => {
  state.isComponentLoading = isComponentLoading
}

const APP_ERROR_UPDATED = (state, appError) => {
  state.appError = appError
}

const APP_NOTIFICATION_UPDATED = (state, notification) => {
  state.appNotification = notification
}

export default {
  IS_PAGE_LOADING_UPDATED,
  IS_COMPONENT_LOADING_UPDATED,
  APP_ERROR_UPDATED,
  APP_NOTIFICATION_UPDATED,
}
